import CachedIcon from '@mui/icons-material/Cached';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import CustomDatePicker from '../../../components/CustomDatePicker';
import DefaultTooltip from '../../../components/DefaultTooltip';
import {
   ControlpanelSecondaryButton,
   ControlpanelSuccessButton,
   ControlpanelWarningButton,
   GrayIconButton,
} from '../../../components/StyledButton';
import { CustomDialog, IOSSwitch } from '../../../components/StyledComponents';

const EnrollFromHistoryDialog = ({ firstName, lastName, onClose }) => {
   const { t } = useTranslation();

   const date = new Date();
   const [selectedFrom, setSelectedFrom] = useState(date);
   const [selectedTo, setSelectedTo] = useState(date);

   return (
      <CustomDialog transitionDuration={300} maxWidth={'xl'} open onClose={onClose} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>
                     {t('common.content-092')}
                     {firstName}&nbsp;{lastName}
                  </p>
                  <DefaultTooltip
                     readMore={true}
                     title='Enroll from history'
                     content={
                        <div className='flex flex-col gap-3'>
                           <p>{t('common.content-093')}</p>
                        </div>
                     }
                  >
                     <QuestionIcon16pxSvg className='fill-[#BDBDBD]' />
                  </DefaultTooltip>
               </div>
               <GrayIconButton onClick={onClose}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>

         <DialogContent>
            <div className='flex items-center gap-2 pt-5'>
               <PersonIcon />
               <p>{t('common.biometrics')}</p>
            </div>
            <form>
               <div className='rounded border border-solid border-[#E5E7EB] py-3 px-5 mt-5'>
                  <div className='grid grid-cols-7 gap-x-5 gap-y-5'>
                     <div className='col-span-12 md:col-span-3'>
                        <label className='block'>{t('common.from')}</label>
                        <div className='mt-2'>
                           <CustomDatePicker value={selectedFrom} onChange={(newValue) => setSelectedFrom(newValue)} readOnly={true} />
                        </div>
                     </div>
                     <div className='col-span-12 md:col-span-3'>
                        <label className='block'>{t('common.to')}</label>
                        <div className='mt-2'>
                           <CustomDatePicker value={selectedTo} onChange={(newValue) => setSelectedTo(newValue)} readOnly={true} />
                        </div>
                     </div>
                     <div className='col-span-12 md:col-span-1 md:flex justify-end items-end'>
                        <ControlpanelWarningButton>
                           <CachedIcon />
                           {t('button.refresh')}
                        </ControlpanelWarningButton>
                     </div>
                  </div>
                  <div className='grid grid-cols-7 pt-5 items-center'>
                     <div className='col-span-5'>
                        <p>{t('common.content-094')}</p>
                     </div>
                     <div className='col-span-2 flex justify-end'>
                        <select className='form-control font-medium w-min' id='selectBiometricType'>
                           <option>{t('common.content-095')}</option>
                           <option>{t('common.content-096')}</option>
                           <option>{t('common.content-097')}</option>
                        </select>
                     </div>
                  </div>
                  <div className='grid grid-cols-7 pt-5 items-center'>
                     <div className='col-span-5'>
                        <p>{t('common.content-098')}</p>
                     </div>
                     <div className='col-span-2 flex justify-end'>
                        <IOSSwitch />
                     </div>
                  </div>
                  <div className='grid grid-cols-7 pt-5 items-center'>
                     <div className='col-span-5'>
                        <p>{t('common.content-099')}</p>
                     </div>
                     <div className='col-span-2 flex justify-end'>
                        <IOSSwitch />
                     </div>
                  </div>
                  <div className='grid grid-cols-7 pt-5 items-center'>
                     <div className='col-span-5'>
                        <p>{t('common.content-100')}</p>
                     </div>
                     <div className='col-span-2 flex justify-end'>
                        <select className='form-control font-medium w-min' id='selectUserGroup'>
                           <option>{t('common.content-101')}</option>
                        </select>
                     </div>
                  </div>
                  <div className='w-full bg-slate-400 p-3 mt-5'>
                     <p>{t('common.content-102')}</p>
                  </div>
               </div>
            </form>
            <div className='pt-10'>
               <p className='text-center'>{t('common.content-103', { page: 1, total: 1 })}</p>
            </div>
         </DialogContent>

         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSuccessButton onClick={onClose}>
                  <PersonAddIcon />
                  <p>{t('button.enroll')}</p>
               </ControlpanelSuccessButton>
               <ControlpanelSecondaryButton onClick={onClose}>
                  <CloseIcon />
                  <p>{t('button.close')}</p>
               </ControlpanelSecondaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default EnrollFromHistoryDialog;
